import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import axios from '../api/axiosInstance';
import { API_ROUTES } from '../constants/apiRoutes';

const TTL = 60 * 60 * 1000; // 1 hour

export const useStaticDataStore = create(
  devtools(
    persist(
      (set, get) => ({
        data: [],
        loaded: false,
        error: null,

        fetchOnce: async () => {
          const { loaded, fetchedAt } = get();

          if (loaded && fetchedAt && Date.now() - fetchedAt < TTL) return;

          try {
            const json = await axios.get(API_ROUTES.STATIC_DATA);
            set({
              data: json,
              loaded: true,
              fetchedAt: Date.now(),
              error: null,
            });
          } catch (err) {
            set({ error: err?.message || 'Request failed', loaded: true });
          }
        },

        reset: () => set({ data: [], loaded: false, error: null }),
      }),
      {
        name: 'static-data-storage',
        partialize: (state) => ({
          data: state.data,
          loaded: state.loaded,
        }),
      },
    ),
  ),
);
